import styled from 'styled-components';
import checkSectionbg from './assets/checkSectionbg.png'

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const CheckSection = styled.div`
  padding: 20px 0;
	background-repeat: no-repeat;
	background-size: cover;
  background-image: url(${checkSectionbg});
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  .prev {
    margin-right: 20px;
  }
`

export const ButtonImg = styled.img`
  width: 42.18%;
  height: 100%;
  cursor: pointer;
  display: block;
`




